import { Box } from '@mui/material';
import { ReactElement, useEffect, useState } from 'react';
import { tokens } from '@synergy/theme-palo';

/**
 * A company logo in a list row. A rectangle rather than a circle, so wide
 * logos keep their proportions; the row height stays (R-265). Persons keep
 * their circle.
 */
export const PaloListLogo = ({ src, name, locked }: { src?: string; name: string; locked?: boolean }): ReactElement => {
    // A file that has gone missing shows the initials, not the browser's broken image.
    const [failed, setFailed] = useState(false);

    useEffect(() => setFailed(false), [src]);

    return (
        <Box
            sx={{
                width: 48,
                height: 24,
                mx: 'auto',
                padding: '2px',
                borderRadius: '4px',
                border: `1px solid ${tokens.color.line}`,
                backgroundColor: tokens.color.surface,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 10,
                fontWeight: 600,
                color: tokens.color.ink2,
                filter: locked ? 'grayscale(1)' : undefined,
                opacity: locked ? 0.45 : 1,
            }}
        >
            {src && !failed ? (
                <Box
                    component="img"
                    src={src}
                    alt={name}
                    loading="lazy"
                    onError={() => setFailed(true)}
                    sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                />
            ) : (
                name
                    .replace(/[^0-9a-z]/gi, '')
                    .substring(0, 2)
                    .toUpperCase()
            )}
        </Box>
    );
};
